import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Palette, User, Package, Wand2 } from "lucide-react";

interface HeroVisualBrandCreatorProps {
  onCreateClick: () => void;
}

export function HeroVisualBrandCreator({ onCreateClick }: HeroVisualBrandCreatorProps) {

  const features = [
    {
      icon: User,
      title: "Person-Modus",
      description: "Professionelle Portraits für Personal Branding"
    },
    {
      icon: Package,
      title: "Produkt-Modus", 
      description: "Hochwertige Produktbilder für Marketing"
    },
    {
      icon: Wand2,
      title: "KI-Generierung",
      description: "3 einzigartige Brand-Visuals pro Anfrage"
    }
  ];

  return (
    <Card 
      className="border-2 border-purple-500"
      data-testid="card-hero-visual-brand-creator"
    >
      <CardContent className="pt-6 pb-6 sm:pt-8 sm:pb-8">
        <div className="flex items-start sm:items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
          <Palette className="w-6 h-6 sm:w-8 sm:h-8 text-purple-500 flex-shrink-0" />
          <h2 className="text-xl sm:text-2xl font-semibold">
            Visual Brand Creator
          </h2>
        </div>

        <p className="text-muted-foreground mb-4">
          Lade ein Foto hoch und unsere KI erstellt 3 professionelle Brand-Visuals daraus.
        </p>

        <div className="grid grid-cols-1 gap-3 mb-6">
          {features.map((feature, index) => (
            <div key={index} className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-full bg-purple-500 text-white flex items-center justify-center font-bold flex-shrink-0">
                <feature.icon className="w-4 h-4" />
              </div>
              <div className="flex-1">
                <h4 className="font-medium">{feature.title}</h4>
                <p className="text-sm text-muted-foreground leading-relaxed break-words">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap gap-3">
          <Button 
            onClick={onCreateClick}
            size="lg"
            className="min-h-[44px] bg-purple-600 hover:bg-purple-700"
            data-testid="button-create-brand-visual"
          >
            <Palette className="w-4 h-4 mr-2" />
            Brand Visual erstellen
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
